import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { chatbotEvents, chatbotSelectors, getCommissionInitialValues, getRentAmount } from 'modules/ui/ChatBot'
// import { partySearchEvents } from '../../../modules/ui/PartySearch'
import { CommissionForm } from '../../components'
import { partyApiSelectors } from '../../../modules/api/party'
import { isEmpty } from 'ramda'
import { portfolioApiSelectors } from '../../../modules/api/portfolio'
import { userApiSelectors } from '../../../modules/api/user'
import { uiEvents } from 'modules/ui/state'

const EMPTY_RESULT_SETS: any[] = []

// Memoize the `[results]` wrap so the prop keeps a stable reference across dispatches.
// `partiesResultsByTags` now returns a stable array (see party selectors), so this only
// recomputes when the agent/agency results actually change — otherwise Search's result
// memoisation breaks and the open dropdown re-renders on every dispatch.
const selectDefaultResultSets = createSelector(
  (state: any) => partyApiSelectors.partiesResultsByTags(state)(['Agent', 'Agency']),
  results => (!isEmpty(results) ? [results] : EMPTY_RESULT_SETS),
)

const mapStateToProps = (state: any) => {
  const currentPortfolioId = chatbotSelectors.getCurrentPortfolioId(state)

  return {
    initialValues: getCommissionInitialValues(state),
    rentAmount: getRentAmount(state),
    defaultResultSets: selectDefaultResultSets(state),
    isDraftPortfolio: portfolioApiSelectors.isDraftPortfolio(state)(currentPortfolioId),
    portfolioId: currentPortfolioId,
    portfolioRentInvoice: portfolioApiSelectors.getRentInvoiceTemplateByPortfolioId(state)(currentPortfolioId),
    isReadOnly: userApiSelectors.isReadOnlyRole(state),
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    redirect: (path: any) => dispatch(uiEvents.redirect(path)),
    handleSubmit: (values: any) => {
      // For managed leases, only submit managementFee, procurementFee should be null
      dispatch(
        chatbotEvents.commissionValuesSubmitted({
          managementFee: values.managementFee,
          procurementFee: null,
        }),
      )
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommissionForm)
